/* eslint no-param-reassign:
  ["error", {
    "props": true,
    "ignorePropertyModificationsFor": ["state"]
  }
] */
import { taggedQuery } from '@signable/query-builder';
import HTTP from '@/utils/http';
import { EventBus } from '@/utils/event-bus';
import AuthProvider from '@/utils/auth';
import crudableFactory from './mixins/crudable';

const crudable = crudableFactory();

const authService = new AuthProvider();

const userModule = {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
    tokenType: null,
    expiresIn: null,
    authenticated: false,
    partner: null,
  },
  mutations: {
    SET_TOKENS(state, { token }) {
      state.partner = token.partner;
      state.accessToken = token.accessToken;
      state.refreshToken = token.refreshToken;
      state.tokenType = token.tokenType;
      state.expiresIn = token.expiresIn;
      state.authenticated = authService.isAuthenticated();
    },
    SET(state, { updated }) {
      state.partner = updated;
    },
  },
  actions: {
    LOGIN({ commit }, { email, password }) {
      return authService.authenticate(email, password).then((token) => {
        if (token.isAuthenticated) commit('SET_TOKENS', { token });
      }).catch((error) => {
        console.log(error);
      });
    },
    GET({ commit }) {
      return HTTP({
        url: 'partners',
      }).then((response) => {
        commit('SET', { updated: response.data.data });
        return response.data.data;
      });
    },
    UPDATE({ commit }, partner) {
      return HTTP({
        method: 'put',
        url: 'partners',
        data: {
          name: partner.name,
          email: partner.email,
        }
      }).then((response) => {
        commit('SET', { updated: response.data.data });
        EventBus.$emit('renderGlobalMessage', ({ message: 'Partner profile was successfully updated', icon: 'check', type: 'success' }));
      }).catch((error) => {
        EventBus.$emit('renderGlobalMessage', ({ message: 'Oops, we could not update the partner profile', icon: 'times', type: 'error' }));
      });
    },
    // UPDATE: crudable.actions.updatePartialApplication({
    //   uriRoot: 'partners',
    //   name: 'user',
    //   props: ['name', 'email', 'password'],
    //   isSingular: true,
    //   include: taggedQuery`partner:email,name`,
    // }),
    GET_USER_FROM_TOKEN(context, { token }) {
      return authService.getUserFromToken(token);
    },
    TEST_ACTION() {
      console.log('Test Action');
    },
  },
  getters: {
    isAuthenticated() {
      return authService.isAuthenticated();
    },
    partner: state => state.partner,
  },
};

export default userModule;
